import React, { FunctionComponent, useContext } from "react";

import { CardFormLayout } from "@ui-components/card-form-layout/CardFormLayout.tsx";

import {
  ClaimDischargeCardIds,
  ClaimDischargeSideRailLabels
} from "../../claim/components/ClaimFormEnums.ts";
import { DischargeContext } from "../context/DischargeContext.ts";
import { ClaimDischargeFormHeader } from "./ClaimDischargeFormHeader.tsx";
import { ClaimDischargeOutcomeSection } from "./ClaimDischargeOutcomeSection.tsx";
import { ClaimDischargeSummarySection } from "./ClaimDischargeSummarySection.tsx";
import { ClaimMultipleClaimTypesSection } from "./ClaimMultipleClaimTypesSection.tsx";

export const ClaimDischargeFormLayout: FunctionComponent = () => {
  const { haveMultipleDisciplines } = useContext(DischargeContext);

  const header = <ClaimDischargeFormHeader />;

  const getSideRailMenuItems = () => {
    const menuItems = [
      {
        text: ClaimDischargeSideRailLabels.Summary,
        id: ClaimDischargeCardIds.Summary
      },
      {
        text: ClaimDischargeSideRailLabels.Outcome,
        id: ClaimDischargeCardIds.Outcome
      }
    ];

    if (haveMultipleDisciplines) {
      menuItems.push({
        text: ClaimDischargeSideRailLabels.MultipleClaimTypes,
        id: ClaimDischargeCardIds.MultipleClaimTypes
      });
    }

    return menuItems;
  };

  return (
    <CardFormLayout header={header} sideRailMenuItems={getSideRailMenuItems()}>
      <ClaimDischargeSummarySection />
      <ClaimDischargeOutcomeSection />
      {haveMultipleDisciplines && <ClaimMultipleClaimTypesSection />}
    </CardFormLayout>
  );
};
